<template>
  <div class="wrapper">
    <!--    < class="animated fadeIn">-->
    <b-row>
      <b-col>
        <b-row>
          <b-col sm="12">
            <b-card header-class="redmfu">
              <div slot="header">
                <strong>สถิติการบันทึกข้อมูลจำแนกสำนักวิชา</strong>
              </div>
              <h4 align="center">สถิติการบันทึกข้อมูลจำแนกสำนักวิชา ประจำปีการศึกษา 2566 </h4>
              <br>
              <b-row>
                <b-col lg="2"></b-col>
                <b-col lg="8">
                  <table border="1" width=100%>
                    <tr class="bg-gray-200">
                      <td rowspan="2" width="30%">
                        <div align=center>สำนักวิชา</div>
                      </td>
                      <td colspan="4" bgcolor="#a9a9a9">
                        <div align=center>จำนวนผู้มีสิทธิ์เข้ารับพระราชทานปริญญาบัตร</div>
                      </td>
                      <td colspan="4" class="bg-green">
                        <div align=center>บันทึกสมบูรณ์</div>
                      </td>
                      <!--                        <td colspan="3" class="bg-yellow">-->
                      <!--                          <div align=center>&#45;&#45;บันทึกไม่สมบูรณ์</div>-->
                      <!--                        </td>-->
                      <!--                        <td colspan="2" class="bg-red">-->
                      <!--                          <div align=center>&#45;&#45;ยังไม่ได้บันทึก</div>-->
                      <!--                        </td>-->
                      <td colspan="13" bgcolor="#003366">
                        <div align=center><font color="white">แจ้งความประสงค์</font></div>
                      </td>
                    </tr>
                    <tr>
                      <!--จำนวนผู้มีสิทธิ์เข้ารับพระราชทานปริญญาบัตร-->
                      <td width="5%" bgcolor="#a9a9a9">
                        <div align=center>ป.ตรี</div>
                      </td>
                      <td width="5%" bgcolor="#a9a9a9">
                        <div align=center>ป.โท</div>
                      </td>
                      <td width="5%" bgcolor="#a9a9a9">
                        <div align=center>ป.เอก</div>
                      </td>
                      <td width="5%" bgcolor="#a9a9a9">
                        <div align=center><strong>รวม</strong></div>
                      </td>
                      <!-- จำนวนผู้มีสิทธิ์เข้ารับพระราชทานปริญญาบัตร-->

                      <td width="5%" class="bg-green">
                        <div align=center>ป.ตรี</div>
                      </td>
                      <td width="5%" class="bg-green">
                        <div align=center>ป.บัณฑิต</div>
                      </td>
                      <td width="5%" class="bg-green">
                        <div align=center><strong>รวม</strong></div>
                      </td>
                      <td width="5%" class="bg-green">
                        <div align=center>คิดเป็นร้อยละ</div>
                      </td>
                      <td width="5%" bgcolor="#003366">
                        <div align=center><font color="white">รับ ป.ตรี</font></div>
                      </td>
                      <td width="5%" bgcolor="#003366">
                        <div align=center><font color="white">รับ ป.โท</font></div>
                      </td>
                      <td width="5%" bgcolor="#003366">
                        <div align=center><font color="white">รับ ป.เอก</font></div>
                      </td>
                      <td width="5%" bgcolor="#003366">
                        <div align=center><strong><font color="white">รวมรับ</font></strong></div>
                      </td>
                      <td width="5%" bgcolor="yellow">
                        <div align=center><font color="blue">ไม่รับ<br>ป.ตรี</font></div>
                      </td>
                      <td width="5%" bgcolor="yellow">
                        <div align=center><font color="blue">ไม่รับ<br>ป.บัณฑิต</font></div>
                      </td>
                      <td width="10%" bgcolor="yellow">
                        <div align=center><strong><font color="blue">รวม<br>ไม่รับ</font></strong></div>
                      </td>
                      <td width="5%" bgcolor="#003366">
                        <div align=center><font color="white">รวม</font></div>
                      </td>
                      <td width="5%" bgcolor="#f5deb3" align=center>บันทึก<br>ไม่สมบูรณ์<br>ป.ตรี</td>
                      <td width="5%" bgcolor="#f5deb3" align=center>บันทึก<br>ไม่สมบูรณ์<br>ป.บัณฑิต</td>
                      <!--                        <td align=center bgcolor="#ff7f50"><font color="white">บันทึกไม่สมบูรณ์</font></td>-->
                      <td width="5%" align=center bgcolor="#ff7f50"><font color="white">ยังไม่ได้บันทึก<br>ป.ตรี</font>
                      </td>
                      <td width="5%" align=center bgcolor="#ff7f50"><font
                        color="white">ยังไม่ได้บันทึก<br>ป.บัณฑิต</font></td>
                      <td width="5%" align=center bgcolor="#ff7f50"><font color="white">
                        <strong>รวม<br>
                          บันทึกไม่สมบูรณ์<br>
                          และ<br>
                          ยังไม่ได้บันทึก</strong></font>
                      </td>
                    </tr>
                    <tr v-for="item in items" v-bind:key="item.FACULTYNAME">
                      <td align=left>{{ item.FACULTYNAME }}</td>
                      <td align=right>{{ item.LEVEL3 }}<!--ตรี--></td>
                      <td align=right>{{ item.LEVEL5 }}<!--โท--></td>
                      <td align=right>{{ item.LEVEL7 }}<!--เอก--></td>
                      <td align=right bgcolor="#d3d3d3">{{ item.TOTAL }}</td>
                      <td align=right>
                        <div v-if="item.C_3 !=0">
                          <a :href="'#/Reportcompleted?year=2566&level=3&id='+item.FACULTYID"> {{ item.C_3 }}</a>
                        </div>
                        <div v-else>0</div>
                      </td>
                      <td align=right>
                        <div v-if="item.C_5+item.C_7!=0">
                          <a :href="'#/Reportcompleted?year=2566&level=5&id='+item.FACULTYID">{{
                              item.C_5 + item.C_7
                            }}</a>
                        </div>
                        <div v-else>0</div>
                      </td>
                      <td bgcolor="#7fffd4">
                        <div align=right>{{ item.COMPLETE_TOTAL }}</div><!--   รวม--></td>
                      <td align=right>{{ ((item.COMPLETE_TOTAL / item.TOTAL) * 100).toLocaleString() }}
                        <!--   %รวม--></td>
                      <td align=right>{{ item.R_3 }}</td>
                      <td align=right>{{ item.R_5 }}</td>
                      <td align=right>{{ item.R_7 }}</td>
                      <td align=right bgcolor="#87cefa">{{ item.CP }}   <!--  รวมรับ--></td>
                      <td align=right bgcolor="#fafad2">{{ item.COMPLETE_503 }} <!--  ไม่รับ ตรี--></td>
                      <td align=right bgcolor="#fafad2">{{ item.COMPLETE_505 }} <!--  ไม่รับ บัณฑิต--></td>
                      <td align=right bgcolor="#f0e68c">{{ item.NO }} <!--  ไม่รับ รวม--></td>
                      <td bgcolor="#7fffd4" align=right><!--   รวม-->{{ item.TT }}</td>
                      <td align=right>
                        <div v-if="item.INCOMPLETE3 + item.INCOMPLETE31 !=0">
                          <a :href="'#/Reportincompleted?year=2566&level=3&id='+item.FACULTYID">
                            {{ item.INCOMPLETE3 + item.INCOMPLETE31 }}
                          </a>
                        </div>
                        <div v-else>
                          0
                        </div>
                      </td>
                      <td align=right>
                        <div v-if="item.INCOMPLETE5 + item.INCOMPLETE51 !=0">
                          <a :href="'#/Reportincompleted?year=2566&level=10&id='+item.FACULTYID">
                            {{ item.INCOMPLETE5 + item.INCOMPLETE51 }}
                          </a>
                        </div>
                        <div v-else>
                          0
                        </div>
                      </td>
                      <td align=right>
                        <div v-if="item.NOTREGIS_3 > 0">
                          <a :href="'#/Reportnotregis?year=2566&level=3&id='+item.FACULTYID">
                            {{ item.NOTREGIS_3 }}
                          </a>
                        </div>
                        <div v-else>0</div>
                      </td>
                      <td align=right>
                        <div v-if="item.NOTREGIS_5 > 0">
                          <a :href="'#/Reportnotregis?year=2566&level=10&id='+item.FACULTYID">
                            {{ item.NOTREGIS_5 }}
                          </a>
                        </div>
                        <div v-else>0</div>
                      </td>
                      <td align=right bgcolor="#deb887">{{ item.NoAction }}</td>
                    </tr>
                    <!--Total-->
                    <tr bgcolor="#fff8dc">
                      <td align=center><strong>รวม</strong></td>
                      <td align=right>{{ total_level3.toLocaleString() }}</td>
                      <td align=right>{{ total_level5.toLocaleString() }}</td>
                      <td align=right>{{ total_level7.toLocaleString() }}</td>
                      <td bgcolor="#696969" align=right>
                        <strong><font color="white">{{ total_student.toLocaleString() }}</font></strong>
                      </td>
                      <td align=right>{{ total_complete3.toLocaleString() }}</td>
                      <td align=right>{{ total_complete5.toLocaleString() }}</td>
                      <td bgcolor="red" align=right>
                        <strong>{{ (total_complete3 + total_complete5).toLocaleString() }}</strong>
                      </td>
                      <td align=right>{{
                          (((total_complete3 + total_complete5) / total_student) * 100).toLocaleString()
                        }}
                      </td>
                      <td align=right>{{ t_3.toLocaleString() }}</td>
                      <td align=right>{{ t_5.toLocaleString() }}</td>
                      <td align=right>{{ t_7.toLocaleString() }}</td>
                      <td align=right bgcolor="#1e90ff">
                        <strong><font color="white">{{ total_cp.toLocaleString() }}</font></strong>
                      </td>
                      <td align=right>{{ total_503.toLocaleString() }}</td>
                      <td align=right>{{ total_505.toLocaleString() }}</td>
                      <td align=right bgcolor="yellow"><strong>{{ total_no.toLocaleString() }}</strong></td>
                      <td align=right bgcolor="red"><strong>{{ total_tt.toLocaleString() }}</strong></td>
                      <td align=right>{{ total_incomplete3.toLocaleString() }}</td>
                      <td align=right>{{ total_incomplete5.toLocaleString() }}</td>
                      <td align=right>{{ total_no3.toLocaleString() }}</td>
                      <td align=right>{{ total_no5.toLocaleString() }}</td>
                      <td align=right bgcolor="#ff7f50"><strong>{{
                          (total_student - total_tt).toLocaleString()
                        }}</strong></td>
                    </tr>

                  </table>
                </b-col>
                <b-col lg="2"></b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row v-if="stateChart">
      <b-col lg="6">
        <b-card header="กราฟแท่งแสดงการเปรียบเทียบจำนวนบัณฑิตเข้ามาบันทึกข้อมูล">
          <div class="chart-wrapper" align="center">
            <bar-example :chart-data="chart"/>
            <charts/>
          </div>
        </b-card>

      </b-col>
      <b-col lg="6">
        <b-card header="กราฟวงกลมแสดงจำนวนบัณฑิตเข้ามาบันทึกข้อมูลจำแนกตามสำนักวิชา">
          <div class="chart-wrapper" align="center">
            <pie-example :chart-data="pie"/>
            <charts/>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
import LineExample from "../views/student/LineExample";
import RadarExample from '@/views/charts/RadarExample'
import PieExample from "../views/student/PieExample";
import {hexToRgba} from "@coreui/coreui/dist/js/coreui-utilities";
import BarExample from "../views/student/BarExample";
// import Charts from "@/views/Charts";
import Charts from "../views/student/Charts";

export default {
  components: {
    Charts,
    BarExample,
    YimoVueEditor,
    LineExample,
    RadarExample,
    PieExample,
  },
  name: "CreateReportfaculty",
  data() {
    return {
      items: [],
      total: 0,
      total_student: 0,
      persent_total: 0,
      total_balance: 0,
      balance: 0,
      count: 0,
      total_complete3: 0,
      total_complete5: 0,
      total_incomplete3: 0,
      total_incomplete5: 0,
      total_no3: 0,
      total_no5: 0,
      total_incomplete: 0,
      total_per_in: 0,
      total_per_c: 0,
      total_level3: 0,
      total_level5: 0,
      total_level7: 0,
      total_level: 0,
      total_incomplete_total: 0,
      total_cp: 0,
      total_no: 0,
      total_70: 0,
      total_tt: 0,
      total_0: 0,
      p_no: 0,
      total_505: 0,
      total_503: 0,
      t_3: 0,
      t_5: 0,
      t_7: 0,
      sum: 0,
      banlance: 0,
      pie: {
        labels: [],
        datasets: [
          {
            backgroundColor: [

              '#D3D3D3', //ศิล เทา
              '#FFFF00',//วิทยาศาสตร์ เหลือง
              '#00BFFF',//การจัดการ ฟ้า
              '#333366',//เทคโนโลยีสารสนเทศ น้ำเงิน
              '#FF7E9D',//อุตสาหกรรมเกษตร ชมพู
              '#F5F5F5',//นิติศาสต ขาว
              '#FF1493',//วิทยาศาสตร์เครื่องสำอาง บานเย็น
              '#98FB98',//วิทยาศาสตร์สุขภาพ เขียวอ่อน
              '#FF6633',//พยาบาลศาสตร์ แสด
              '#006400',//เวชศาสตร์ชะลอวัยและฟื้นฟูสุขภาพ เขียวเข้ม
              '#288C28',//แพทย์ เขียว
              '#660066',//ทันตแพทยศาสต ม่วงแก่
              '#FFFFCC',//นวัตกรรมสังคม เหลืองนวล
              '#FF0000',//จีนวิทยา แดง
              '#5CEEE6',//การแพทย์บูรณาการ เขียวอมฟ้า
              '#000000',

            ],
            data: []
            //  data: [40, 20, 80, 10,40, 20, 80, 10,40, 20, 80, 10,12,14]
          }
        ]


      },
      chart: {
        label: [],
        datasets: [
          {
            label: 'ทั้งหมด',
            backgroundColor: hexToRgba('#006699', 100),
            data: []
          },
          {
            label: 'บันทึกไม่สมบูรณ์',
            backgroundColor: hexToRgba('#E598BB', 100),
            data: []
          },
          {
            label: 'บันทึกสมบูรณ์',
            backgroundColor: hexToRgba('#7AFFCF', 100),
            data: []
          }
        ]
      },
      stateChart: false
    };
  },

  methods: {
    getStatistic() {
      api
        .getStatisticFaculty()
        .then(res => {
          // console.log("x==", res)
          this.items = res.data.data;

          for (var i = 0; i < res.data.data.length; i++) {
            // console.log("x==",res.data.data.length)
            res.data.data[i].CP = res.data.data[i].COMPLETE_10 + res.data.data[i].COMPLETE_20
              + res.data.data[i].COMPLETE_21 + +res.data.data[i].COMPLETE_22 + res.data.data[i].COMPLETE_23
              + res.data.data[i].COMPLETE_24 + res.data.data[i].COMPLETE_30 + res.data.data[i].COMPLETE_40;
            res.data.data[i].NO = res.data.data[i].COMPLETE_50 + res.data.data[i].COMPLETE_60;
            // res.data.data[i].COMPLETE_TOTAL== res.data.data[i].C_3 + res.data.data[i].C_5+res.data.data[i].C_7 ;
            // res.data.data[i].NO=res.data.data[i].COMPLETE_50 +res.data.data[i].COMPLETE_60-res.data.data[i].INCOMPLETE_TOTAL;

            this.total_incomplete_total = this.total_incomplete_total + res.data.data[i].INCOMPLETE_TOTAL
            // res.data.data[i].TT = res.data.data[i].NO + res.data.data[i].CP + res.data.data[i].COMPLETE_70;
            res.data.data[i].TT = res.data.data[i].NO + res.data.data[i].CP;
            res.data.data[i].NoAction = res.data.data[i].TOTAL - res.data.data[i].TT;
            // console.log("NoAction==",res.data.data[i].NoAction )
            res.data.data[i].XX = res.data.data[i].TOTAL - res.data.data[i].TT;
            this.total_cp = this.total_cp + res.data.data[i].CP
            this.total_no = this.total_no + res.data.data[i].NO
            this.total_70 = this.total_70 + res.data.data[i].COMPLETE_70
            this.total_tt = this.total_tt + res.data.data[i].TT
            this.total_0 = this.total_0 + res.data.data[i].XX
            // แท่ง
            this.chart.label.push(res.data.data[i].FACULTYNAME);
            this.chart.datasets[0].data.push(res.data.data[i].TOTAL);
            // this.chart.datasets[1].data.push(res.data.data[i].INCOMPLETEALL);
            this.chart.datasets[1].data.push(res.data.data[i].INCOMPLETE_TOTAL);
            // res.data.data[i].SUMCOMPLETE = res.data.data[i].COMPLETE3 + res.data.data[i].COMPLETE5;
            res.data.data[i].SUMCOMPLETE = res.data.data[i].C_3 + res.data.data[i].C_5 + res.data.data[i].C_7;
            res.data.data[i].COMPLETEPERCEN = (res.data.data[i].SUMCOMPLETE / res.data.data[i].TOTAL) * 100;
            this.chart.datasets[2].data.push(res.data.data[i].SUMCOMPLETE);
            //ดึงข้อมูลมา sum
            this.total = this.total + res.data.data[i].COUNTSTD;
            // this.total_complete3 = this.total_complete3 + res.data.data[i].COMPLETE3;
            this.total_complete3 = this.total_complete3 + res.data.data[i].C_3;
            // console.log("ก่อน",this.total_complete5,res.data.data[i].COMPLETE5);
            // this.total_complete5 = this.total_complete5 + res.data.data[i].COMPLETE5;
            this.total_complete5 = this.total_complete5 + res.data.data[i].C_5 + res.data.data[i].C_7;
            // console.log("==",this.total_complete5);
            this.total_incomplete3 = this.total_incomplete3 + res.data.data[i].INCOMPLETE3 + res.data.data[i].INCOMPLETE31;
            this.total_incomplete5 = this.total_incomplete5 + res.data.data[i].INCOMPLETE5 + res.data.data[i].INCOMPLETE51;

            this.total_no3 = this.total_no3 + res.data.data[i].NOTREGIS_3;
            this.total_no5 = this.total_no5 + res.data.data[i].NOTREGIS_5;
            this.total_incomplete = this.total_incomplete + res.data.data[i].INCOMPLETEALL;
            this.total_level3 = this.total_level3 + res.data.data[i].LEVEL3;
            this.total_level5 = this.total_level5 + res.data.data[i].LEVEL5;
            this.total_level7 = this.total_level7 + res.data.data[i].LEVEL7;
            this.t_3 = this.t_3 + res.data.data[i].R_3;
            this.t_5 = this.t_5 + res.data.data[i].R_5;
            this.t_7 = this.t_7 + res.data.data[i].R_7;
            this.p_no = this.p_no + res.data.data[i].INCOMPLETEALL
            // this.total_per_c=this.total_per_c + res.data.data[i].PERCENT_C;

            this.total_503 = this.total_503 + res.data.data[i].COMPLETE_503
            this.total_505 = this.total_505 + res.data.data[i].COMPLETE_505
            //วงกลม
            this.pie.labels.push(res.data.data[i].FACULTYNAME);
            this.pie.datasets[0].data.push(res.data.data[i].SUMCOMPLETE);
            if (i == 14) {
              this.pie.labels.push('ยังไม่ได้บันทึก+บันทึกไม่สมบูรณ์');
              //  this.pie.datasets[0].data.push(this.total_incomplete + this.total_incomplete5 + this.total_incomplete3);
              //   console.log("Faculty ALL==", this.total_student,this.total_tt)
              var xx = 3122 - this.total_tt;
              this.pie.datasets[0].data.push(xx);
            }
            // console.log("pie==", this.pie)
            // console.log("this.total==",this.total);
          }
          // console.log("Faculty ALL==", res)
          this.total_student = this.total_level3 + this.total_level5 + this.total_level7;
          this.total_balance = this.total_student - this.total;
          this.persent_total = (this.total / this.total_student) * 100;

          // console.log("res==",res);
          // console.log("res.data.data.length==",res.data.data.length);
          // console.log("total==",this.total);
          // console.log("persent_total==",this.persent_total);
          this.stateChart = true
        })
        .catch(err => {
          console.log("getStatistic", err.toString());
        });
    }
  },
  created() {
    this.getStatistic();
    api.onSetHeader();
  }
};
</script>
<style>
</style>
